/* eslint max-len: 0 */
import React from 'react';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import { Layout, LayoutItem } from './Layout';
import ProductsDirectory from './ProductsDirectory.jsx';

class SectionAllProducts extends React.Component {
  render() {
    const sectionBg = require('images/all-products-bg.svg');
    const title = i18n.translate('allProducts.title');

    return (
      <Section id="all-products" color="red" sectionBg={sectionBg} title={title}>
        <Layout>
          <LayoutItem>
            <p dangerouslySetInnerHTML={{ __html: i18n.translate('allProducts.p1') }}></p>
          </LayoutItem>
          <LayoutItem>
            <ProductsDirectory />
          </LayoutItem>
        </Layout>
      </Section>
    );
  }
}

export default SectionAllProducts;



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionAllProducts.jsx
 **/